import type { FC, PropsWithChildren } from 'react';

import type { CmsRendering } from '@eneco/cms-adapter';

import { RenderingContext } from './rendering-context';

/**
 * Publicly mount a rendering into the context. Useful for bridge components
 * that bring in a rendering from outside the `<Placeholder>` machinery —
 * e.g. legacy adapters that receive a pre-built rendering as props and want
 * descendants to read it via `useContent` / `useParams` / `usePlaceholder`.
 */
export const RenderingProvider: FC<PropsWithChildren<{ rendering: CmsRendering }>> = ({
  rendering,
  children,
}) => <RenderingContext.Provider value={rendering}>{children}</RenderingContext.Provider>;
